export const PATIENT_MANUAL_URL =
  "https://drive.google.com/file/d/1z2n-0TgUPfVjGHvAV-0Zl_ve8VoxLFUn/view?usp=share_link";
export const HEALTH_PRO_MANUAL_URL =
  "https://drive.google.com/file/d/1cuIxKNM2YHewkTXD0hhpZI7SPGmwPLNs/view?usp=share_link";
